import { HYRouter, HYUserInfo, HUYASdk } from '@hy-hybrid/kiwi-js-sdk';
import HUYA from '@/modules/taf/jce/index';
const IN_HUYA_APP = navigator.userAgent.indexOf('huya') > 0;


const getCookieVal = (cookieName: string) => {
  const arrstr = document.cookie.split('; ');
  for (let i = 0; i < arrstr.length; i = i + 1) {
    const kv = arrstr[i].split('=');
    if (kv[0] === cookieName) return decodeURIComponent(kv[1]);
  }
  return '';
}

let userInfo: Record<string, string> = {
  uid: '',
  udbToken: '',
  guid: '',
  sHuYaUA: '',
}
const userId = new HUYA.UserId();
const getUserInfo = async () => {
  if (!userInfo.uid) {
    if (IN_HUYA_APP) {
      const currentUserInfo = await HYUserInfo.getCurrentUserInfo({});
      console.log('currentUserInfo', currentUserInfo);

      const deviceInfo: any = await new Promise(resolve => {
        // @ts-ignore
        HUYASdk.getDeviceInfo({
          complete: (resp: any) => {
            resolve(resp)
          },
        });
      });
      console.log('deviceInfo', deviceInfo);
      const appInfo: any = await await new Promise(resolve => {
        // @ts-ignore
        HUYASdk.getAppInfo({
          complete: (resp: any) => {
            resolve(resp)
          },
        });
      });
      console.log('appInfo', appInfo);
      userInfo = {
        uid: currentUserInfo.uid,
        udbToken: currentUserInfo.udbToken,
        guid: deviceInfo.guid,
        sHuYaUA: appInfo.huyaUA,
      }
      console.warn('用户信息', userInfo)
    } else {
      userInfo = {
        uid: getCookieVal('yyuid'),
        udbToken: '',
        guid: getCookieVal('guid'),
        sHuYaUA: 'adr&13.0.0&official&29',
      }
    }

    userId.lUid = userInfo.uid,
    userId.sToken = userInfo.udbToken,
    userId.sGuid = userInfo.guid,
    userId.sHuYaUA = userInfo.sHuYaUA,
    userId.sCookie = document.cookie

  }
  return {
    userInfo,
    userId,
  }
}

const goto = (url: string) => {
  HYRouter.openUrl({
    url,  // 虎牙内部跳转协议,例如yykiwi://xxx
  });
}


const urlParams = new URLSearchParams(location.search);

const gotoTaskCenter = (url: string) => {
  // 从任务中心进来的话，就返回
  // 2:任务中心
  const rso = urlParams.get('rso');
  if (rso === '2') {
    HYRouter.quit();
  } else {
    HYRouter.openUrl({
      url,  // 虎牙内部跳转协议,例如yykiwi://xxx
    });
  }
}


const listenerCallbackArr: Array<(params: any)=>void> =  [];
let addEventListenerStatus = false;

const listenerMessage = (callback: ()=>void) => {
  listenerCallbackArr.push(callback);
  if (!addEventListenerStatus) {
    addEventListenerStatus = true;
    window.addEventListener('message', event => {
      if (/\.huya\.com$/.test(event.origin) && event.data) {
        let obj: any = null;
        try {
          if (typeof event.data === 'string') {
            obj = JSON.parse(event.data);
          } else {
            obj = event.data;
          }
        } catch (err) {

        }

        if (obj && obj.eventType === 'udbSafeAuth') {
          listenerCallbackArr.forEach(callbackFn => {
            callbackFn(obj);
          });
          listenerCallbackArr.length = 0;
        }
      }
    });
  }
}

const cleanListenerCallback = () => {
  listenerCallbackArr.length = 0;
}





const getGradeIcon = (level: number) => {
  if (!level) {
    return '';
  }
  if (level <= 9) {
    return 1;
  }
  if (level <= 19) {
    return 2;
  }
  if (level <= 29) {
    return 3;
  }
  if (level <= 39) {
    return 4;
  }
  if (level <= 49) {
    return 5;
  }
  return 6;
}

function dateFormat(oData: any, formatStr: string) {
  let str = formatStr;
  const Week = ['日', '一', '二', '三', '四', '五', '六'];
  str = str.replace(/yyyy|YYYY/, oData.getFullYear());
  str = str.replace(/yy|YY/, oData.getYear() % 100 > 9 ? (oData.getYear() % 100).toString() : '0' + (oData.getYear() % 100));
  str = str.replace(/MM/, oData.getMonth() + 1 > 9 ? (oData.getMonth() + 1).toString() : '0' + (oData.getMonth() + 1));
  str = str.replace(/M/g, oData.getMonth() + 1);
  str = str.replace(/w|W/g, Week[oData.getDay()]);
  str = str.replace(/dd|DD/, oData.getDate() > 9 ? oData.getDate().toString() : '0' + oData.getDate());
  str = str.replace(/d|D/g, oData.getDate());
  str = str.replace(/hh|HH/, oData.getHours() > 9 ? oData.getHours().toString() : '0' + oData.getHours());
  str = str.replace(/h|H/g, oData.getHours());
  str = str.replace(/mm/, oData.getMinutes() > 9 ? oData.getMinutes().toString() : '0' + oData.getMinutes());
  str = str.replace(/m/g, oData.getMinutes());
  str = str.replace(/ss|SS/, oData.getSeconds() > 9 ? oData.getSeconds().toString() : '0' + oData.getSeconds());
  str = str.replace(/s|S/g, oData.getSeconds());
  return str;
}


export {
  getCookieVal,
  getUserInfo,
  goto,
  listenerMessage,
  cleanListenerCallback,
  gotoTaskCenter,
  IN_HUYA_APP,
  urlParams,
  getGradeIcon,
  dateFormat,
}
